import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
import { SelectedSnippetsStore } from "$/stores/SelectedSnippetsStore";

export class BottomPopUpModalAction {
    constructor(
        action = () => Promise.resolve(),
        cancel = () => Promise.resolve(),
        name = "",
        loadingText = "",
        color = "",
    ) {
        this.action = action;
        this.cancel = cancel;
        this.name = name;
        this.loadingText = loadingText;
        this.color = color;
    }

    async deleteSelectedSnippets(selectedSnippets) {
        for (let snippet of selectedSnippets) {
            await ActiveTopicStore.deleteSnippet(snippet.id);
        }
        SelectedSnippetsStore.clear();
    }
}
